// extracted by mini-css-extract-plugin
export var details = "_g5-0";
export var inspectorPopover = "_g5-1";